import { Button, message, Modal, Popconfirm, Spin, Table } from "antd";
import { DeleteOutlined, EditOutlined, EyeOutlined, PlusOutlined } from "@ant-design/icons";
import { useEffect, useMemo, useState } from "react";
import InputCustomer from "./inputData";
import { API } from "../../../setup/setupAxios";

const TableResult = () => {
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [showModal, setShowModal] = useState(false)
    const [editData, setEditData] = useState(null);
    const [viewMode, setViewMode] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleAdd = () => {
        setEditData(null);
        setViewMode(false);
        setShowModal(true);
    };
    const handleEdit = (record) => {
        setEditData(record);
        setViewMode(false);
        setShowModal(true);
    };
    const handleView = (record) => {
        setEditData(record);
        setViewMode(true);
        setShowModal(true);
    };
    const handleCloseModal = () => {
        setViewMode(false);
        setEditData(null);
        setShowModal(false);
    };
    const fetchData = async () => {
        setLoading(true)
        try {
          const response = await API("/api/customer");
          setData(response.data.data);
        } catch (error) {
          console.error('Error fetching data', error);
        } finally {
            setLoading(false);
        }
    };
    const paginatedData = useMemo(() => {
        const start = (currentPage - 1) * pageSize;
        if(data) {
            return data.slice(start, start + pageSize);
        } else if (!data) {
            return null
        }
    }, [data, currentPage, pageSize]);
    const handleDelete = async (record) => {
        try {
            await API.delete(`/api/customer/${record}`);
            await fetchData();
            message.success("Data berhasil dihapus");
        } catch (error) {
            console.error("Gagal menghapus:", error);
            message.error("Gagal menghapus data");
        }
    }
    useEffect(() => {
        fetchData()
    }, [])
    const columns = [
        {
            title: "No",
            dataIndex: "no",
            key: "no",
            align: "center",
            width: 70,
            render: (text, record, index) => (currentPage - 1) * pageSize + index + 1
        },
        {
            title: "No Member",
            dataIndex: "noMember",
            key: "noMember",
            width: 150,
            align: 'center',
            render: (text) => text || "-"
        },
        {
            title: "Nama",
            dataIndex: "nama",
            key: "nama",
            width: 200,
            align: 'center'
        },
        {
            title: "Alamat",
            dataIndex: "alamat",
            key: "alamat",
            width: 350,
            align: 'center'
        },
        {
            title: "Nomor Telepon",
            dataIndex: "noTelepon",
            key: "noTelepon",
            width: 200,
            align: 'center'
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            width: 220,
            align: 'center',
            render: (text) => text || "-"
        },
        {
            title: "Action",
            dataIndex: "",
            key: "",
            fixed: "right",
            width: 160,
            render: (text, record, index) => (
                <div style={{display: "flex", gap: 6, justifyContent: "center"}}>
                    <Button 
                        type="primary" 
                        icon={<EditOutlined />} 
                        onClick={() => handleEdit(record)}
                        title="Edit Customer"
                    />
                    <Button 
                        type="default" 
                        icon={<EyeOutlined />} 
                        onClick={() => handleView(record)}
                        title="Lihat Detail"
                    />
                    <Popconfirm
                        placement="right"
                        title="Anda yakin akan menghapus data ini?"
                        onConfirm={() => handleDelete(record.id)}
                        okText="Hapus"
                        cancelText="Batal"
                    >
                        <Button 
                            type="primary"
                            danger
                            icon={<DeleteOutlined />}
                            title="Hapus Customer"
                        />
                    </Popconfirm>
                </div>
            )
        }
    ]
    return(
        <div style={{ padding: "8px 0" }}>
            <Button type="primary" style={{marginBottom: 20}} onClick={handleAdd}><PlusOutlined /> Tambah Data Customer</Button>
            {data ? (
                <Table 
                    size="small"
                    className="compact-table"
                    dataSource={paginatedData || []}
                    columns={columns}
                    rowKey="id"
                    width={"60%"}
                    scroll={{ x: 'max-content' }}
                    pagination={{
                        current: currentPage,
                        pageSize: pageSize,
                        total: data.length,
                        onChange: (page, size) => {
                            setCurrentPage(page);
                            setPageSize(size);
                        }
                    }}
                />
            ):(
                <Spin spinning={loading} tip="Memuat data..." />
            )}
            <Modal 
                title={editData ? "Edit Data Customer" : "Input Data Customer"}
                open={showModal}
                onCancel={handleCloseModal}
                width={800}
                footer={null}
            >
                <InputCustomer 
                    modal={() => setShowModal(false)}
                    editData={editData}
                    viewMode={viewMode}
                    hitApi={fetchData}
                />
            </Modal>
        </div>
    )
}
export default TableResult;